import React from "react";
import "./donutChart.css";

export default class DonutChart extends React.Component {

  render() {
    const halfsize = this.props.size * 0.5;
    const radius = halfsize - this.props.strokewidth * 0.5;
    const circumference = 2 * Math.PI * radius;
    const strokeval = (this.props.value * circumference) / 100;
    const dashval = strokeval + " " + circumference;
    const trackstyle = { strokeWidth: this.props.strokewidth };
    const indicatorstyle = {
      strokeWidth: this.props.strokewidth,
      strokeDasharray: dashval,
      stroke: this.props.color,
    };

    const rotateval = "rotate(-90 " + halfsize + "," + halfsize + ")";
    return (
      <div className={this.props.className}>
        <svg
          width={this.props.size}
          height={this.props.size}
          className="donutchart"
        >
          <circle
            r={radius}
            cx={halfsize}
            cy={halfsize}
            transform={rotateval}
            style={trackstyle, {stroke:'#dae2e5'}}
            className="donutchart-track"
          />
          <circle
            r={radius}
            cx={halfsize}
            cy={halfsize}
            transform={rotateval}
            style={indicatorstyle}
            className="donutchart-indicator"
          />
          <text
            className="donutchart-text"
            x={halfsize}
            y={halfsize+5}
            style={{ textAnchor: "middle" }}
          >
            <tspan className="donutchart-text-val">{this.props.value}</tspan>
            <tspan className="donutchart-text-percent">%</tspan>
          </text>
        </svg>
        <tspan className="donutchart-text-label" y={halfsize + 10}>
          {this.props.valuelabel}
        </tspan>
      </div>
    );
  }
}

DonutChart.defaultProps = {
  value: 0,
  valuelabel: "",
  size: 135,
  strokewidth: 26,
};
